export enum EAlertType {
  Favorites = 'favorites',
  Chats = 'chats',
  Hide = 'hide',
}

interface IViewData {
  headingType: string;
}

/**
 * Параметры `/v3/open-auth-modal/` микрофронтенда header-frontend
 */
export interface IOpenAuthModalParameters {
  autoRefresh?: boolean;
  alert?: EAlertType | null;
  useDefaultView?: boolean;
  viewData?: IViewData | null;
  source?: string | null;
}

export interface IHeaderMicrofrontendAPI {
  openAuthModal(parameters?: IOpenAuthModalParameters): Promise<void>;
  updateHeader(): Promise<void>;
}

export interface IMicrofrontendsAPI {
  header: IHeaderMicrofrontendAPI;
}
